<template>
  <v-card flat>
    <v-card-text>
      <v-layout wrap :style="{ margin: '-8px' }">
        <v-flex xs12 class="pa-2">
          <v-switch
            :input-value="value.change_rich_menu_status"
            :label="$t('rich_menu_turn_on')"
            color="primary"
            hide-details
            @change="$emit('input', { ...value, change_rich_menu_status: $event })"
          />
        </v-flex>
        <v-flex v-if="value.change_rich_menu_status" xs12 class="pa-2">
          <v-layout wrap :style="{ margin: '-8px' }">
            <v-flex xs12 class="pa-2">
              <label class="d-block caption">{{ $t('select_rich_menu') }}</label>
              <v-autocomplete
                :value="value.rich_menu_id"
                :items="items"
                item-text="rich_menu_contents.name"
                item-avatar="rich_menu_image_url"
                item-value="rich_menu_id"
                hide-details
                outline
                single-line
                @change="$emit('input', { ...value, rich_menu_id: $event })"
              >
                <template #item="{ item }">
                  <v-list-tile-avatar>
                    <img
                      :src="item.rich_menu_image_url"
                      alt="Image"
                      :style="{ objectFit: 'cover' }"
                    />
                  </v-list-tile-avatar>
                  <v-list-tile-content>{{ item.rich_menu_contents.name }}</v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs12 class="pa-2">
              <img
                v-if="selected"
                :src="selected.rich_menu_image_url"
                alt="Image"
                :style="{ display: 'block', width: '100%', maxWidth: '480px', margin: '0 auto' }"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import lineRichMenuApi from '@/api/line-rich-menu'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    selected() {
      return this.items.find((item) => item.rich_menu_id === this.value.rich_menu_id)
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      try {
        const response = await lineRichMenuApi.getItems(this.selectedBot.pageid, {
          limit: 1000,
          offset: 0,
          published: true,
          is_active: true
        })
        if (response.status !== 200) return
        const { data } = response.data
        this.items = data
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/RichMenuForm.vue